import { FORM } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import EditorConditionBase from './EditorConditionBase';
import EditorRelatedConditionsGroupContainer from './EditorRelatedConditionsGroupContainer';
import EditorRelatedConditionsRefineButton from './EditorRelatedConditionsRefineButton';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { useFormSubmissionFilter } from '../../hooks/useFormSubmissionFilter';
import EditorConditionRefinements from './EditorConditionRefinements';
import { useOperatorOptions } from '../../hooks/useOperatorOptions';
import EditorUIFieldSet from './EditorUIFieldSet';
import { useTranslationHelpers } from '../../hooks/useTranslationHelpers';
import UISelect from 'UIComponents/input/UISelect';
import emptyFunction from 'react-utils/emptyFunction';
import ConditionError from '../common/ConditionError';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import EditorConditionAsset from './EditorConditionAsset';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import EditorConditionRefinementsContainer from './EditorConditionRefinementsContainer';
import { NUMBER_REFINEMENT } from 'customer-data-filters-ui/converters/objectSeg/constants/constants';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FORM_NOT_FILLED_OUT = 'FormNotFilledOut';
const EditorFormSubmissionRelatedConditionsGroup = props => {
  var _condition$field3;
  const {
    condition,
    conditionPath,
    dataSeleniumInfo,
    inputUse
  } = props;
  const {
    getTrackerInstance,
    props: {
      baseFilterFamily,
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onRefineFilter,
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionValueChange,
    onFieldConditionOperatorChange,
    onFieldConditionValueAndOperatorChange
  } = useFieldConditionChange(FORM, conditionPath, condition);
  const {
    statusCondition,
    pageCondition,
    dateRefinementCondition,
    numberRefinementCondition,
    refinementConditionsEmptyValue,
    onPageChange,
    onPageDelete
  } = useFormSubmissionFilter(condition, onFieldConditionValueChange);
  const {
    getFieldLabelString
  } = useTranslationHelpers(FORM);
  const {
    options: operatorOptions,
    getOperatorByName
  } = useOperatorOptions(FORM, statusCondition);
  const hasInPlaceRefinementSelection = !!useOnePanel;
  const onSelectedOptionChange = evt => {
    var _getTrackerInstance, _condition$field, _condition$field2;
    const operatorName = evt.target.value.value;

    // delete "Number of Submissions" refinement when "Contact has not filled out form" is selected
    if (hasInPlaceRefinementSelection && operatorName === FORM_NOT_FILLED_OUT && condition.numberRefinement) {
      onFieldConditionValueAndOperatorChange(getOperatorByName(operatorName), condition.remove(NUMBER_REFINEMENT));
    } else {
      onFieldConditionOperatorChange(getOperatorByName(operatorName));
    }
    (_getTrackerInstance = getTrackerInstance()) === null || _getTrackerInstance === void 0 || _getTrackerInstance.track('changedFilterOperator', {
      operator: operatorName,
      primaryObjectTypeId: baseFilterFamily,
      property: (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.name,
      type: (_condition$field2 = condition.field) === null || _condition$field2 === void 0 ? void 0 : _condition$field2.type,
      version: useOnePanel ? '2' : '1'
    });
  };

  //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
  const userHasNoAccess = (_condition$field3 = condition.field) === null || _condition$field3 === void 0 ? void 0 : _condition$field3.userHasNoAccess;
  const heading = /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(EditorUIFieldSet, {
      legend: getFieldLabelString(statusCondition.field),
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        as: "div",
        children: /*#__PURE__*/_jsx(EditorConditionAsset, {
          condition: condition,
          filterFamily: FORM,
          inputUse: inputUse
        })
      }), /*#__PURE__*/_jsx(UISelect, {
        "data-selenium-info": dataSeleniumInfo,
        "data-selenium-test": "fr-filter-operator-select",
        "data-test-id": "fr-filter-operator-select",
        disabled: userHasNoAccess,
        onSelectedOptionChange: onSelectedOptionChange,
        optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
          message: true,
          option: option
        }),
        options: operatorOptions,
        value: condition.constructor.toString(),
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
      }), /*#__PURE__*/_jsx(ConditionError, {
        condition: condition
      }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
        condition: condition
      }), !hasInPlaceRefinementSelection && /*#__PURE__*/_jsx(EditorRelatedConditionsRefineButton, {
        dataSeleniumInfo: dataSeleniumInfo,
        disabled: userHasNoAccess,
        onClick: () => onRefineFilter(FORM, conditionPath)
      }), hasInPlaceRefinementSelection && !userHasNoAccess && /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(EditorConditionRefinementsContainer, {
          inputUse: inputUse,
          condition: condition,
          conditionPath: conditionPath,
          filterFamily: FORM,
          onConditionChange: onFieldConditionValueChange,
          emptyRefinementConditions: refinementConditionsEmptyValue
        })
      })]
    })
  });
  return hasInPlaceRefinementSelection ? /*#__PURE__*/_jsx(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: FORM,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath)
  }) : /*#__PURE__*/_jsxs(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: FORM,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath),
    children: [pageCondition && /*#__PURE__*/_jsx(EditorConditionBase, {
      inputUse: inputUse,
      condition: pageCondition,
      conditionPath: conditionPath,
      filterFamily: FORM,
      onConditionDelete: onPageDelete,
      onConditionOperatorChange: emptyFunction,
      onConditionValueChange: onPageChange
    }), /*#__PURE__*/_jsx(EditorConditionRefinements, {
      inputUse: inputUse,
      condition: condition,
      filterFamily: FORM,
      onConditionChange: onFieldConditionValueChange,
      dateRefinement: dateRefinementCondition,
      numberRefinement: numberRefinementCondition
    })]
  });
};
export default EditorFormSubmissionRelatedConditionsGroup;